// initialize map object
var map = L.map('map').setView([28, 10], 2.45);
// add basemap layer
L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  subdomains: 'abcd',
  maxZoom: 19

}).addTo(map);
// initialize marker clustering object
var markers = L.markerClusterGroup({
  showCoverageOnHover: false,
  spiderfyDistanceMultiplier: 1.5
});

// add markers from geojson files
var markersLayer = new L.GeoJSON.AJAX(["https://alonshvartsman.github.io/bitrawr-geojson/africa.geojson","https://alonshvartsman.github.io/bitrawr-geojson/asia.geojson", "https://alonshvartsman.github.io/bitrawr-geojson/europe.geojson", "https://alonshvartsman.github.io/bitrawr-geojson/north-america.geojson", "https://alonshvartsman.github.io/bitrawr-geojson/south-america.geojson"], {
  pointToLayer: function(feature, latlng) {
    return L.marker(latlng);
  },
  onEachFeature: function(feature, layer) {
    layer.bindPopup('<div class="popupBox" style="background: rgb(255, 255, 255);">\
              <div class="titleBox"><span class="titleBoxText" title="'+  feature.properties.name + '"><b>' +  feature.properties.name + ' </b></span>\
              <span class="titleDescription" title="'+  feature.properties.description + '"> ' +  feature.properties.description + ' </span>\
              </div>\
              <div class="popupBoxContent">\
                <span title="'+  feature.properties.address + '"><b><i class="icon-home"></i> </b> ' +  feature.properties.address + ' </span>\
                <span title="'+  feature.properties.hours + '"><b><i class="icon-clock-o"></i> </b> ' +  feature.properties.hours + ' </span>\
                <span title="'+  feature.properties.phone_number + '"><b><i class="icon-phone"></i> </b> ' +  feature.properties.phone_number + ' </span>\
                <span title="'+  feature.properties.website + '"><b><i class="icon-globe"></i> </b> <a href="' + feature.properties.website + '" target="_blank" rel="noopener noreferrer nofollow">' + feature.properties.website + '</a></span>\
              </div>\
            </div>', {offset: new L.Point(0, -1)});
  }
});

// wait when geojson files loaded and add markes to marker cluster group
markersLayer.on('data:loaded', function () {
  markers.addLayer(markersLayer);
  map.addLayer(markers);
});
// document.getElementById('loader').style.display = 'none';
